const kinds = [["ordered", /^\d+[.)]\s+/], ["bullet", /^[-*•]\s+/], ["heading", /^#{1,6}\s+/]] as const;
const bold = /\*\*(.+?)\*\*/g;

type ProseBlock =
  | { readonly kind: "paragrafo"; readonly text: string; readonly heading: boolean }
  | { readonly kind: "lista"; readonly ordered: boolean; readonly items: readonly string[] };

function lineOf(raw: string) {
  const trimmed = raw.trim();
  const found = kinds.find(([, pattern]) => pattern.test(trimmed));
  const syntax = found?.[1].exec(trimmed)?.[0] ?? "";
  const kind = found?.[0] ?? (trimmed === "" ? "blank" : "text");
  return { kind, text: trimmed.slice(syntax.length) };
}

export function proseOf(text: string): ProseBlock[] {
  const blocks: ProseBlock[] = [];
  for (const chunk of text.split(/\n\s*\n/)) {
    let lines: string[] = [];
    let list: { readonly ordered: boolean; readonly items: string[] } | undefined;
    const endParagraph = () => {
      if (lines.length > 0) blocks.push({ kind: "paragrafo", text: lines.join(" "), heading: false });
      lines = [];
    };
    const endList = () => {
      if (list) blocks.push({ kind: "lista", ...list });
      list = undefined;
    };
    for (const line of chunk.split("\n").map(lineOf)) {
      if (line.kind === "ordered" || line.kind === "bullet") {
        endParagraph();
        if (list?.ordered !== (line.kind === "ordered")) endList();
        list ??= { ordered: line.kind === "ordered", items: [] };
        list.items.push(line.text);
      } else if (line.kind !== "blank") {
        endList();
        if (line.kind === "heading") endParagraph();
        if (line.kind === "heading") blocks.push({ kind: "paragrafo", text: line.text, heading: true });
        else lines.push(line.text);
      }
    }
    endParagraph();
    endList();
  }
  return blocks;
}

export const boldParts = (text: string): string[] => text.split(bold);

const lines = (text: string, item: string) =>
  proseOf(text).flatMap((block) => (block.kind === "lista" ? block.items.map((one) => `${item}${one}`) : [block.text]));

export const proseLine = (text: string): string => lines(text, "").join(" ").replace(bold, "$1");

export const proseText = (text: string): string => lines(text, "- ").join("\n").replace(bold, "$1");
